var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12.5V16.875H12.5M16.4766 16.4754L11.875 11.875M3.125 7.5V3.125H7.5M3.52344 3.52461L8.125 8.125M12.5 3.125H16.875V7.5M16.4754 3.52344L11.875 8.125M7.5 16.875H3.125V12.5M3.52461 16.4766L8.125 11.875",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.9e31f44a4ca5e198892d7157321a3464.svg";
export { ForwardRef as ReactComponent };